module.exports = __webpack_public_path__ + "img/icon01.54a6280c.png";